import React from 'react';
import PropTypes from 'prop-types';
import { NavFragment } from '@paypalcorp/globalnavsdk/NavFragment';

export function QuantumLeapFooter({ belowFooter }) {
  return (
    <div className="document-footer">
      <NavFragment type="footer">
        {belowFooter
          ? (
            <NavFragment.After>
              {belowFooter}
            </NavFragment.After>
          ) : null}
      </NavFragment>
    </div>
  );
}

QuantumLeapFooter.propTypes = {
  belowFooter: PropTypes.node,
};

QuantumLeapFooter.defaultProps = {
  belowFooter: null,
};
